import React from 'react'
import Header from './Header.js';
import Home from './Home.js';

function HomePage() {
  return (
    <div className='homepage'>
        <Header/>
        <Home/>
    </div>
  )
}

export default HomePage